import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ServicePriceActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Shop/ServicePrice/ServicePriceBrowser")
	}

	render() {
		return (
			<Activity 
				name="ServicePrice"
				RenderedComponent={this.RenderedComponent}
				context="ServicePrice"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ServicePriceActivity)
